import { FieldErrors, useFieldArray, useFormContext } from "react-hook-form";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import RefundAllocationRow from "./RefundAllocationRow";
import { RefundFormValues } from "../RefundSchema";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface PropTypes {
  resetAllocations?: React.MouseEventHandler<HTMLButtonElement>;
}

export default function RefundAllocationTable({ resetAllocations }: PropTypes) {
  const { formState } = useFormContext<RefundFormValues>();
  const { fields } = useFieldArray<RefundFormValues>({ name: "allocations" });

  // const paymentAmount = formatCents(watch('amount') ?? 0);
  const allocationErrors: FieldErrors<RefundFormValues>["allocations"] =
    formState.errors["allocations"];

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 1 }}
      >
        <Box>
          <Typography variant="h5">
            Choose how much to refund from each payment
          </Typography>
          {/* <Typography variant="body2">
                        (Charges that have been paid in full are not shown)
                    </Typography> */}
          {allocationErrors && (
            <Typography variant="body2" color="error">
              {allocationErrors?.root?.message}
            </Typography>
          )}
        </Box>
        <ButtonGroup variant="outlined">
          <Button onClick={resetAllocations} color="error">
            Reset
          </Button>
        </ButtonGroup>
      </Box>

      <TableContainer component={Paper}>
        <Table
          sx={{ minWidth: 650 }}
          size="small"
          aria-label="Payment Refund Amounts"
        >
          <TableHead>
            <TableRow>
              <TableCell>Payment Memo</TableCell>
              <TableCell align="right">Total Paid</TableCell>
              <TableCell align="right">Allocated</TableCell>
              <TableCell align="right">Previously Refunded</TableCell>
              <TableCell align="right">Amount Refundable</TableCell>
              <TableCell align="left">Amount To Refund</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {fields.map((field, index) => (
              <RefundAllocationRow key={field.id} index={index} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
